<template>
  <el-pagination :class=location @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="this.page.currentPage" :page-sizes="pageSizes" :page-size="this.page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="this.page.total">
  </el-pagination>
</template>

<script>
export default {
  props: {
    page: {},
    pageSizes:{
      type:Array,
      default:()=>{
        return [5,10,50, 100, 200, 300,500,1000,1500,2000,3000,5000,8000]
      }
    },
    location: {
      tyep: String,
      default: 'center',
    }
  },
  data() {
    return {
    }
  },
  methods: {
    // 改变每页数量时触发
    handleSizeChange(val) {
      this.page.pageSize = val
      this.$emit('getData')
    },
    // 改变页码时触发
    handleCurrentChange(val) {
      this.page.currentPage = val
      this.$emit('getData')
    }
  },
  watch:{
    'page.total':{
      deep:true,
      handler:function(){
        let totalPage=Math.ceil((this.page.total) / this.page.pageSize)
        // console.log(totalPage,this.page.currentPage);
        if(this.page.currentPage>1&&this.page.currentPage>totalPage){
          this.page.currentPage--
          this.$emit('getData')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.center {
  text-align: center;
  padding-top: 20px;
}
.right {
  text-align: right;
  padding-top: 20px;
}
.left {
  text-align: left;
  padding-top: 20px;
}
</style>